import { Dispatch, SetStateAction, useReducer } from 'react';
import { MappedType } from '../typings/mappedType';

function createReducer(localStoragePath: string, isObject: boolean) {
  return (_: any, newState: any) => {
    if (newState) localStorage.setItem(localStoragePath, isObject ? JSON.stringify(newState) : newState as string);
    return newState;
  };
}

export function useLocalStorage(localStoragePath: string, defaultValue: string | MappedType, isObject = false): [any, Dispatch<SetStateAction<any>>] {
  let initialValue = defaultValue;
  const value = localStorage.getItem(localStoragePath);
  if (value) {
    if (isObject) {
      initialValue = JSON.parse(value);
    } else {
      initialValue = value;
    }
  }

  const reducer = createReducer(localStoragePath, isObject);
  const [state, setState] = useReducer(reducer, initialValue);

  return [state, setState];
}
